import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useMediaQuery,
  useTheme,
  Paper,
  Chip,
} from '@mui/material'

import { useStyles } from './../styles'
import { ModalWrapper } from 'src/components/modal-wrapper'
import { Loader } from 'src/components/loader'
import { useGetFaceScansInfo } from 'src/hooks/admin-tools/use-get-fake-scans-info.hook'

interface IProps {
  open: boolean
  handleClose: () => void
  handleDelete: () => void
  isLoading: boolean
}

export const DeleteFakeScansModal = ({ isLoading, open, handleDelete, handleClose }: IProps) => {
  const classes = useStyles()
  const theme = useTheme()
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'))

  const { data, isLoading: isDataLoading } = useGetFaceScansInfo()

  if (isDataLoading || !data) {
    return null
  }

  return (
    <ModalWrapper className={classes.modalWrapper} open={open} onClose={handleClose}>
      <Box
        sx={{
          display: 'flex',
          flex: 1,
          flexDirection: 'column',
          gap: 3,
          width: isSmallScreen ? '95vw' : 800,
          maxHeight: '75vh',
          overflowY: 'auto',
          p: 3,
        }}
      >
        <Typography variant="h5" fontWeight="bold" textAlign="center">
          Confirm Deletion of Scans
        </Typography>

        <Typography variant="subtitle1" color="error" textAlign="center" fontWeight={600}>
          Total scans to delete: {data?.total ?? 0}
        </Typography>

        {data?.byUser && data.byUser.length > 0 ? (
          <TableContainer component={Paper} sx={{ maxHeight: 300 }}>
            <Table stickyHeader size="small" aria-label="scans by user table">
              <TableHead>
                <TableRow>
                  <TableCell>User</TableCell>
                  <TableCell align="right">Scans Count</TableCell>
                  {/* Add more columns here if your IFekeScansByUserDataData has more relevant fields */}
                </TableRow>
              </TableHead>
              <TableBody>
                {data.byUser.map((userItem, index) => (
                  <TableRow key={userItem.userId ?? index}>
                    <TableCell>
                      <Box display="flex" alignItems="center" gap={1}>
                        <Typography noWrap>{userItem.email || 'Unknown User'}</Typography>
                        {userItem.suspended && <Chip label="Susp." size="small" color="error" />}
                      </Box>
                    </TableCell>
                    <TableCell align="right">{userItem.count ?? '-'}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <Typography textAlign="center" color="text.secondary" mt={2}>
            No users with fake scans found.
          </Typography>
        )}
      </Box>

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          gap: 2,
          pt: 2,
          borderTop: `1px solid ${theme.palette.divider}`,
        }}
      >
        <Button onClick={handleClose} variant="outlined" size="small" disabled={isLoading}>
          Cancel
        </Button>
        <Button
          onClick={() => {
            handleDelete()
            handleClose()
          }}
          // sx={{ bgcolor: theme.palette.custom.warning2 }}
          variant="contained"
          size="small"
          color="error"
          disabled={isLoading || isDataLoading || !data?.total}
          startIcon={isLoading ? <Loader isStatic size={18} /> : null}
        >
          Confirm
        </Button>
      </Box>
    </ModalWrapper>
  )
}
